import React, { useEffect, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import Carousels from './Carousel'

import { getFavoriteItem, setFavoriteItems } from '@/app/products/ProductsMain'
import { ReactGAEvent } from '@/components/ReactGAs'

const setProductData = (data) => {
	const _s = {
		category_id: data?.category_id,
		category_name: data?.category_name,
		commodity_id: data?.commodity?.commodity_id,
		commodity_name: data?.commodity?.commodity_name,
		required_weight: '0',
		thumbnail_url: data?.thumbnail_url,
	}
	return _s
}

const Banner = ({ categoryData }) => {
	const router = useRouter()
	const _getFavoriteItem = getFavoriteItem() || []
	const [selectedProducts, setSelectedProducts] = useState(_getFavoriteItem)
	const [checkAddToCart, setCheckAddToCart] = useState()
	const [currentProduct, setCurrentProduct] = useState()

	useEffect(() => {}, [categoryData])

	useEffect(() => {
		categoryData && setCurrentProduct(setProductData(categoryData))
		setCheckAddToCart(checkAddToCartHandler(categoryData?.category_id))
	}, [selectedProducts, categoryData])

	const checkAddToCartHandler = (_categoryId) => {
		return _getFavoriteItem?.find((item) => item?.category_id === unescape(_categoryId))
	}

	const addOrderItemHandler = (orderItem) => {
		const _orderItem = [...selectedProducts, orderItem]
		setSelectedProducts(_orderItem)
		setFavoriteItems(_orderItem)
		ReactGAEvent({ action: 'Click', event: 'view_page', label: 'Blank', category:'Next' })
	}

	return (
		<Row className='banner-top'>
			<Col xs={12} md={6} className='gx-5'>
				<Carousels thumbnailUrl={categoryData?.thumbnail_url} images={categoryData?.images} />
			</Col>
			<Col xs={12} md={6} className='gx-5'>
				<Row>
					<p className='blog-details-banner-heading'>{categoryData?.category_name}</p>
				</Row>
				<Row>
					<div
						className='product-description sun-editor-editable tag-text-direction my-2'
						dangerouslySetInnerHTML={{ __html: categoryData?.description1 }}
					/>
				</Row>

				<Row>
					<Col xs={12} md={12}>
						<Row className='border-top'>
							<div className='d-flex flex-wrap gy-3'>
								<div className='col-md-6 col-12'>
									<span className='product-item'>Brands</span>
								</div>

								<div className='col-md-6 col-12 d-flex flex-wrap'>
									{categoryData?.specifications?.brands.length ? (
										categoryData?.specifications?.brands?.map((item, index) => (
											<span className='blog-finance m-1' key={index}>
												{item}
											</span>
										))
									) : (
										<span className='m-1'>-</span>
									)}
								</div>
							</div>

							<div className='d-flex flex-wrap gy-3'>
								<div className='col-md-6 col-12'>
									<span className='product-item'>Material (Grades)</span>
								</div>
								<div className='col-md-6 col-12 d-flex flex-wrap'>
									{categoryData?.specifications?.grade ? (
										categoryData?.specifications?.grade?.split(',')?.map((item, index) => (
											<span className='blog-finance m-1' key={index}>
												{item}
											</span>
										))
									) : (
										<span className='m-1'>-</span>
									)}
								</div>
							</div>

							<div className='d-flex flex-wrap gy-3'>
								<div className='col-md-6 col-12'>
									<span className='product-item'>Customizations</span>
								</div>
								<div className='col-md-6 col-12 d-flex flex-wrap'>
									{categoryData?.specifications?.customizations?.length ? (
										categoryData?.specifications?.customizations?.map((item, index) => (
											<span className='blog-finance m-1' key={index}>
												{item}
											</span>
										))
									) : (
										<span className='m-1'>-</span>
									)}
								</div>
							</div>
						</Row>
					</Col>
				</Row>
				<Row className='buy-now g-3'>
					<Col xs={12} lg={4} md={12}>
						<Button
							className='border-0'
							onClick={() => {
								!checkAddToCart ? addOrderItemHandler(currentProduct) : router.push('/products')
							}}
							// disabled={checkAddToCart}
						>
							<p className='add-to-card-text'> {!checkAddToCart ? `Add to Cart` : 'Go To Cart'}</p>
						</Button>
					</Col>
					<Col xs={12} lg={6} md={12}>
						<Link href={'/products'}>
							<Button variant='outline-secondary' className='card-selected'>
								<p className='primary-text add-to-card-text'>Explore More Products</p>
							</Button>
						</Link>
					</Col>
				</Row>
			</Col>
		</Row>
	)
}

export default Banner
